import React, { useState, useEffect, useContext } from 'react';
// import Modal from 'react-modal';
import { useNavigate } from 'react-router-dom';
import styles from './ClientProfile.module.css';
import "./comment.css";
import BackBtn from '../../../assets/BackBtn.svg';
import Dropdown from '../../../Components/DropDownSelect/Dropdown';
import DropDownV2 from '../../../Components/DropDownBox/DropdownV2';
import AdminContext from '../../../Context/adminContext';
import { useMsal } from "@azure/msal-react";
import EditIcon from '../../../assets/Edit.svg';
import MapPin from '../../../assets/MapPin.svg';
import Skeleton from '@mui/material/Skeleton';
import { Box, CircularProgress } from '@mui/material';
import { useSnackbar } from 'notistack';
import '../../../Components/YesNoButtonsCSS/YesNoButtons.css';
import Table from '../../../Components/Table/TableV2';
import SliderSwitch from '../../../Components/SliderSwitch/SliderSwitch';
import CompanyContactsTable from '../../../Components/Table/CompanyContactsTable';
import EditClientProfilePopup from '../../../Components/EditClientProfilePopup/EditClientProfilePopup';
import ClientFollowUpPopUp from '../../../Components/ClientFollowUpPopUp/ClientFollowUpPopUp';
import AttachClientRelationPopup from '../../../Components/AttachClientRelationPopup/AttachClientRelationPopup';
import PlannerTasksBoard from "../../../Components/PlannerTasksBoard/PlannerTasksBoard";


import { useSelector, useDispatch } from "../../../redux/store";
import {
  getClientActivityOptions,
  postClientLogbook,
  getClientProfile,
  getClientLogbook,
  updateClientProfile,
  searchClientsForAttachment,
  attachClientRelation,
  detachClientRelation,
  deleteClient,
} from "../../../redux/slices/client";
import { fetchPlannerTasks, clearPlannerTasks } from '../../../redux/slices/plannerTasks';


function ClientProfile() {

  const dispatch = useDispatch();
  const { accounts } = useMsal();
  const account = accounts[0];
  const { enqueueSnackbar } = useSnackbar();
  const navigate = useNavigate();
  const clientID = parseInt(window.location.hash.substring(1));
  const [jobData, setJobData] = useState(null);

  const [loading, setLoading] = useState(false);
  const [isResponseShown, setIsResponseShown] = useState(false);
  const [apiResponse, setApiResponse] = useState(null);
  const [logBook, AssignLogBook] = useState([]);
  const [isLogBookLoading, setIsLogBookLoading] = useState(true);

  const pulsatingTime = 500; // 5 seconds in milliseconds

  // const [modalIsOpen, setModalIsOpen] = useState(false);
  // const [text, setText] = useState('');
  const [displayEditDiv, setDisplayEditDiv] = useState(false);
  const [followUpModal, setFollowUpModal] = useState(false);
  const [proProjectListData, setProProjectListData] = useState([]);
  const [BPProjectListData, setBPProjectListData] = useState([]);
  const [companyProjectListData, setCompanyProjectListData] = useState([]);
  const [includeLostOpps, setIncludeLostOpps] = useState(false);

  // Relationship attachment state
  const [selectedProfessional, setSelectedProfessional] = useState(null);
  const [selectedCompany, setSelectedCompany] = useState(null);
  const [showAttachPopup, setShowAttachPopup] = useState(false);

  const editable = useContext(AdminContext);
  const [activity, setActivity] = useState("");
  const [comment, setComment] = useState("");
  const [activityOptions, setActivityOptions] = useState([]);
  const [activeTab, setActiveTab] = useState('Invoicing');

  const commentInput = document.querySelector(".CommentInput");

  const fetchDataRecords = async () => {
    dispatch(getClientProfile(clientID));
  };

  const fetchLogBook = async () => {
    setIsLogBookLoading(true);
    dispatch(getClientLogbook(clientID));
  };

  const clientActivityOptions = useSelector((state) => state.client.clientActivityOptions);
  const clientProfile = useSelector((state) => state.client.clientProfileData);
  const clientProfileLoading = useSelector((state) => state.client.clientProfileLoading);
  const clientLogbook = useSelector((state) => state.client.clientLogbookData);
  const clientLogbookLoading = useSelector((state) => state.client.clientLogbookLoading);
  const attachProfessionalOptions = useSelector((state) => state.client.attachProfessionalOptions);
  const attachCompanyOptions = useSelector((state) => state.client.attachCompanyOptions);
  const isClientRelationSubmitting = useSelector((state) => state.client.isClientRelationSubmitting);
  const plannerTasks = useSelector((state) => state.plannerTasks);

  useEffect(() => {
    const fetchData = async () => {
      if (clientID) {
        // Clear local page-level data to avoid showing stale data while new profile loads
        setJobData(null);
        setIsLogBookLoading(true);
        setProProjectListData([]);
        setBPProjectListData([]);
        setCompanyProjectListData([]);
        AssignLogBook([]);
        setSelectedProfessional(null);
        setSelectedCompany(null);

        try {
          // Trigger redux fetches - loading state is derived from redux flags
          fetchDataRecords();
          fetchLogBook();
          dispatch(getClientActivityOptions());
        } catch (error) {
          console.error('Error fetching client data:', error);
        }
      }
    };
    fetchData();
  }, [clientID]);

  const fetchPlannerTasksData = async () => {
    if (!clientID) return;
    try {
      await dispatch(fetchPlannerTasks({ jobNumber: clientID }));
    } catch (error) {
      console.error("Error fetching planner tasks:", error);
    }
  };

  useEffect(() => {
    if (activeTab === 'Tasks') {
      fetchPlannerTasksData();
    }
  }, [activeTab, clientID]);

  useEffect(() => {
    if (Array.isArray(clientActivityOptions)) {
      setActivityOptions(clientActivityOptions);
    }
  }, [clientActivityOptions]);

  useEffect(() => {
    if (clientProfile) {
      setJobData(clientProfile);
      setProProjectListData(clientProfile.ClientProjectListProfessional);
      setBPProjectListData(clientProfile.ClientProjectListHomeOwner);
      // Wire company project list if present on the profile payload
      setCompanyProjectListData(clientProfile.ClientProjectListCompany || []);
    }
  }, [clientProfile]);

  useEffect(() => {
    if (clientLogbook) {
      AssignLogBook(clientLogbook);
      setIsLogBookLoading(false);
    }
  }, [clientLogbook]);

  // Match ProjectProfile loading UX: show a centered spinner while core profile data loads.
  if (loading || clientProfileLoading || !jobData) {
    return (
      <Box
        sx={{
          display: 'flex',
          alignItems: 'flex-start',
          paddingTop: '250px',
          justifyContent: 'center',
        }}
      >
        <CircularProgress size={65} />
      </Box>
    );
  }

  const handleUpdateClick = async (formValues) => {
    setLoading(true);
    try {
      // Strip internal linking fields before calling the update API
      const { linkedCompanyID, linkedCompanyName, ...apiPayload } = formValues || {};

      const res = await dispatch(updateClientProfile(apiPayload, account.username, clientID));
      if (res && res.message) setApiResponse(res.message);

      // If the client is a Company and a primary professional was selected in the popup,
      // attach the relationship here (base: company, contact: professional).
      if (
        formValues.clientType === 'Company' &&
        formValues.linkedCompanyID
      ) {
        try {
          await dispatch(
            attachClientRelation({
              clientID,
              relatedClientID: formValues.linkedCompanyID,
              relationType: 'professional',
              updatedBy: account.username,
            })
          );
          enqueueSnackbar('Professional attached successfully.', { variant: 'success' });
        } catch (attachError) {
          console.error("Error attaching professional during client update:", attachError);
          enqueueSnackbar('Failed to attach professional to client.', { variant: 'error' });
        }
      }
    } catch (error) {
      console.error("Error in Client Info Update:", error);
    } finally {
      setIsResponseShown(true);
      setLoading(false);
      // refresh via redux and local fetch
      fetchDataRecords();
    }
  };

  const handleDeleteClick = async (clientID) => {
    setLoading(true);
    try {
      await dispatch(deleteClient(clientID, account.username));
      enqueueSnackbar('Client deleted successfully', { variant: 'success' });
      // Navigate back to client list after successful deletion
      navigate('/clients');
    } catch (error) {
      const errorMessage = error.response?.data?.message || error.message || 'Failed to delete client. Please try again.';
      enqueueSnackbar(errorMessage, { variant: 'error' });
    } finally {
      setLoading(false);
    }
  };

  const handleEditClientProfile = () => {
    setDisplayEditDiv(true);
  };

  const handleBack = () => {
    if (window.history.length > 1) {
      navigate(-1);
    } else {
      navigate('..');
    }
  };

  const handleMapOpen = (address) => {
    const query = encodeURIComponent(address);
    const url = `https://www.google.com/maps/search/?api=1&query=${query}`;
    window.open(url, '_blank');
  };

  const handleActivityChange = (value) => {
    setActivity(value);
  };

  // handle comment change
  const handleCommentChange = (e) => {
    setComment(e.target.value);
  };

  // handle Confirmation click
  const handleConfirmationClick = async () => {
    setLoading(true);
    try {
      await dispatch(postClientLogbook(clientID, activity, comment, account.username));
      // Clear form fields after successful submission
      setActivity("");
      setComment("");
      enqueueSnackbar('Client logbook updated successfully.', { variant: 'success' });
    } catch (error) {
      console.error("Error:", error);
      setApiResponse("Error occurred");
      enqueueSnackbar('Failed to update client logbook.', { variant: 'error' });
    } finally {
      setLoading(false);
      // Also trigger Redux refresh to keep global state in sync
      // Local refresh for this page
      fetchDataRecords();
      fetchLogBook();
      setIsResponseShown(true);
    }
  };

  //handle Post Btn Click
  const handlePostBtnClick = async () => {
    if (comment.trim() === "") {
      // if comment is empty, add 'invalid' class and don't open modal
      document.querySelector(".CommentInput").classList.add("invalid");
      setTimeout(() => {
        commentInput.classList.remove("invalid");
      }, pulsatingTime);
      return "Invalid";
    } else {
      // if comment is not empty, remove 'invalid' class if it exists
      document.querySelector(".CommentInput").classList.remove("invalid");

      // directly handle confirmation without opening the modal
      handleConfirmationClick();
    }
  };

  // Search handler for relationship dropdowns (professionals / companies)
  const handleAttachSearchChange = (searchTerm, clientType) => {
    if (!searchTerm || !clientType) return;
    dispatch(searchClientsForAttachment(searchTerm, clientType));
  };

  const handleAttachProfessional = async () => {
    if (!selectedProfessional) return;
    try {
      await dispatch(
        attachClientRelation({
          clientID,
          relatedClientID: selectedProfessional.value,
          relationType: 'professional',
          updatedBy: account.username,
        })
      );
      enqueueSnackbar('Professional attached successfully.', { variant: 'success' });
      setSelectedProfessional(null);
    } catch (error) {
      console.error("Error attaching professional to client:", error);
      enqueueSnackbar('Failed to attach professional to client.', { variant: 'error' });
    }
  };

  const handleAttachCompany = async () => {
    if (!selectedCompany) return;
    try {
      await dispatch(
        attachClientRelation({
          clientID,
          relatedClientID: selectedCompany.value,
          relationType: 'company',
          updatedBy: account.username,
        })
      );
      enqueueSnackbar('Company attached successfully.', { variant: 'success' });
      setSelectedCompany(null);
    } catch (error) {
      console.error("Error attaching company to client:", error);
      enqueueSnackbar('Failed to attach company to client.', { variant: 'error' });
    }
  };

  const handleDetachProfessional = async (professionalID) => {
    try {
      await dispatch(
        detachClientRelation({
          clientID,
          relatedClientID: professionalID,
          relationType: 'professional',
          updatedBy: account.username,
        })
      );
      enqueueSnackbar('Professional unlinked successfully.', { variant: 'success' });
    } catch (error) {
      console.error("Error detaching professional from client:", error);
      enqueueSnackbar('Failed to unlink professional from client.', { variant: 'error' });
    }
  };

  const fullAddress = jobData ? [
    jobData.address_1,
    jobData.address_2,
    jobData.town,
    jobData.post_code
  ].filter(Boolean).join(', ') : "--";

  let billPayerText = '--';
  if (jobData && jobData.tags && Array.isArray(jobData.tags)) {
    const yearRegex = /^(19|20)\d{2}$/;
    const years = jobData.tags
      .filter(tag => yearRegex.test(String(tag)))
      .map(year => parseInt(year, 10));

    if (years.length > 0) {
      const earliestYear = Math.min(...years);
      billPayerText = `${earliestYear} Bill Payer`;
    }
  }

  // Table data for client statistics
  const statsTableData = {
    headers: ['Total Promoted', 'Win Rate', 'Projects Promoted'],
    rows: [[
      jobData?.total_promoted_fees || '£0.00',
      jobData?.win_rate || '0%',
      jobData?.promoted_project_count || '0',
    ]],
    dataName: 'ClientStats',
  };

  // Helpers for project list filtering and counts
  const isLostRow = (row) => Array.isArray(row) && row.some((cell) => typeof cell === 'string' && cell.toLowerCase().includes('lost'));
  const proAllRows = proProjectListData?.rows || [];
  const proShownRows = includeLostOpps ? proAllRows : proAllRows.filter((row) => !isLostRow(row));
  const proShownCount = proShownRows.length;

  const bpAllRows = BPProjectListData?.rows || [];
  const bpShownRows = includeLostOpps ? bpAllRows : bpAllRows.filter((row) => !isLostRow(row));
  const bpShownCount = bpShownRows.length;

  const companyAllRows = companyProjectListData?.rows || [];
  const companyShownRows = includeLostOpps ? companyAllRows : companyAllRows.filter((row) => !isLostRow(row));
  const companyShownCount = companyShownRows.length;

  return (
    <div className={styles.clientProfileContent}>
      <div className={styles.ClientBaseInfo}>
        <div className={styles.BackBtn} onClick={handleBack}>
          <img src={BackBtn} alt='Back' />
        </div>
        <div className={styles.Topbar}>
          <div className={styles.TopbarInner}>
            <div className={styles.ButtonsWrapper}>
              <ul className={styles.TopbarList}>
                {['Invoicing', 'Timesheets', 'Tasks'].map((tab) => (
                  <li key={tab}>
                    <div
                      className={`${styles.row} ${activeTab === tab ? styles.ClickedOn : ''}`}
                      onClick={() => setActiveTab(tab)}
                    >
                      {tab}
                    </div>
                  </li>
                ))}
              </ul>
              <div className={styles.line}></div>
            </div>
          </div>
        </div>
      </div>
      <div className={styles.ClientName}>
        {jobData ? `${jobData.name}` : "Loading..."}
        {editable && jobData &&
          <img
            className={`${styles.editIcon} ${styles.Address}`}
            onClick={handleEditClientProfile}
            src={EditIcon}
            alt="EditIconAddress"
          />
        }
      </div>
      <div className={styles.ClientAddress}>
        {fullAddress}
        <img
          className={styles.pinIcon}
          onClick={() => handleMapOpen(fullAddress)}
          src={MapPin}
          alt="MapPinAddress"
        />
      </div>
      <div className={styles.ProjectTags}>

        {/* Tags */}
        {jobData && jobData.tags && jobData.tags.length > 0 ? (
          <ul>
            {[...new Set(jobData.tags)].map(tag => {
              const cleanedTag = String(tag).replace(/\(On\/Off\)/g, '').trim();
              return (
                <li className={styles.Tag} key={cleanedTag}>{cleanedTag}</li>
              );
            })}
          </ul>
        ) : (
          <li className={styles.PlaceHolderBubble} />
        )}

        <div className={styles.LeftAlignment}>
          {/* Type Bubble */}
          {jobData && (
            <React.Fragment>
              {jobData.home_owner && (
                <li className={styles.StatusBubble}>HOME OWNER</li>
              )}
              {jobData.professional && (
                <li className={styles.StatusBubble}>PROFESSIONAL</li>
              )}
            </React.Fragment>
          )}
        </div>
      </div>

      <div className={styles.ClientProfileScrollableArea}>
        <div className={styles.ProjectInformation} style={{ display: 'flex', justifyContent: 'space-between' }}>

          <div className={styles.ProjectDetails} style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', flex: '1', gap: '40px' }}>

            <div className={styles.ProjectStageInfo} style={{ flex: '1' }}>
              {editable && jobData && <img className={`${styles.editIcon} ${styles.ProjectInfo}`} onClick={handleEditClientProfile} src={EditIcon} alt="EditIcon" />}

              <div className={styles.HorBlock1}>
                <div className={styles.FieldContainer}>
                  <div className={`${styles.PhoneNo} ${styles.FieldTitle}`}>Phone No:</div>
                  <span className={styles.InfoText}>{jobData && jobData.phone_no ? jobData.phone_no : '--'}</span>
                </div>
                <div className={styles.FieldContainer}>
                  <div className={`${styles.Address} ${styles.FieldTitle}`} style={{ marginLeft: '10.5px' }}>Website:</div>
                  <span className={styles.InfoText}>{jobData && jobData.website ? jobData.website : '--'}</span>
                </div>
                <div className={styles.FieldContainer}>
                  <div className={`${styles.Email} ${styles.FieldTitle}`} style={{ marginLeft: '25px' }}>Email:</div>
                  <span className={styles.InfoText}>{jobData && jobData.email ? jobData.email : '--'}</span>
                </div>
              </div>
            </div>

            <div className={styles.ProjectStats} style={{ flex: '1' }}>
              {editable && jobData && <img className={`${styles.editIcon} ${styles.ProjectInfo}`} onClick={handleEditClientProfile} src={EditIcon} alt="EditIcon" />}

              <div className={styles.HorBlock1}>
                <div className={styles.FieldContainer}>
                  <div className={`${styles.JobFee} ${styles.FieldTitle}`}> Preferred Runner: </div>
                  <span className={styles.InfoText}>{jobData && jobData.pref_runner ? jobData.pref_runner : '--'}</span>
                </div>
                {jobData && jobData.home_owner && (
                  <div className={styles.FieldContainer}>
                    <div className={`${styles.JobType} ${styles.FieldTitle}`} style={{ marginLeft: '46px' }}>Bill Payer: </div>
                    <span className={styles.InfoText}>{billPayerText}</span>
                  </div>
                )}
                {jobData && jobData.professional && (
                  <div className={styles.FieldContainer}>
                    <div className={`${styles.JobType} ${styles.FieldTitle}`} style={{ marginLeft: '40px' }}>Profession: </div>
                    <span className={styles.InfoText}>{jobData.profession || '--'}</span>
                  </div>
                )}
                <div className={styles.FieldContainer}>
                  <div className={`${styles.JobType} ${styles.FieldTitle}`} style={{ marginLeft: '36px' }}>Client Type: </div>
                  <span className={styles.InfoText}>
                    {jobData ? (
                      `${jobData.professional ? 'Professional' : ''}${jobData.professional && (jobData.home_owner || jobData.company) ? ', ' : ''}${jobData.home_owner ? 'Home Owner' : ''}${(jobData.professional || jobData.home_owner) && jobData.company ? ', ' : ''}${jobData.company ? 'Company' : ''}`
                    ) : '--'}
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>

        {jobData.company && (
          <>
            <div className={styles.SubTitleRow}>
              <div className={styles.SubTitle}>Company Contacts</div>
              {editable && (
                <button
                  className={styles.LongBtn}
                  onClick={() => {
                    setSelectedProfessional(null);
                    setSelectedCompany(null);
                    setShowAttachPopup(true);
                  }}
                >
                  MANAGE LINKS
                </button>
              )}
            </div>
            <CompanyContactsTable
              contacts={jobData.company_contacts}
              clickableRowAdd={'../clients/ClientProfile'}
              onDetachProfessional={handleDetachProfessional}
            />
          </>
        )}

        {jobData.contacts_company && jobData.contacts_company.length > 0 && (
          <>
            <div className={styles.SubTitle}>Contacts Company</div>
            <CompanyContactsTable
              contacts={jobData.contacts_company}
              clickableRowAdd={'../clients/ClientProfile'}
              onDetachProfessional={handleDetachProfessional}
            />
          </>
        )}

        <div className={styles.SubTitle}> Client Log Book </div>

        <div className={styles.CommentsArea}>
          <div className={styles.CommentsSection}>

            <div className={styles.Activity}>
              Activity:{" "}
              <span className={styles.Dropdown}>
                <Dropdown
                  options={activityOptions}
                  selectedValue={activity}
                  onValueChange={handleActivityChange} // update selected activity when a new one is chosen
                  options_width='130%'
                />
              </span>
            </div>

            <p className={styles.Comment}>
              Comment:
              <textarea
                className="CommentInput" //{styles.CommentInput}
                placeholder={comment ? "" : "Comment..."}
                onFocus={(e) => (e.target.placeholder = "")}
                onBlur={(e) => {
                  if (!e.target.value) e.target.placeholder = "Comment...";
                }}
                wrap="hard"
                value={comment}
                onChange={handleCommentChange}
              />
            </p>

            <p className={styles.Post}>
              {activity === 'Person of Interest (On/Off)' || activity === 'Update/Follow up' ? (
                <button
                  className={`${styles.PostBtn} ${!jobData ? `${styles.disabled}` : ""}`}
                  onClick={!jobData ? null : () => setFollowUpModal(true)}
                >
                  POST
                </button>
              ) : (
                <button
                  className={`${styles.PostBtn} ${!jobData ? `${styles.disabled}` : ""}`}
                  onClick={!jobData ? null : handlePostBtnClick}
                >
                  POST
                </button>
              )}
            </p>
          </div>
        </div>

        <div id="Logbook" className={styles.LogBook}>
          <div className={styles.LogBookTable}>
            <table>
              <tbody>
                {isLogBookLoading
                  ? Array(8)
                    .fill()
                    .map((_, index) => (
                      <tr className={styles.LogRow} key={index}>
                        <td
                          className={styles.LogStatus}
                        >
                          <Skeleton
                            animation="wave"
                            variant="rounded"
                            width={108}
                            height={25}
                          />
                        </td>
                        <td
                          className={`${styles.LogActivity}`}
                        >
                          <Skeleton
                            animation="wave"
                            variant="rounded"
                            width={120}
                            height={20}
                          />
                        </td>
                        <td
                          className={`${styles.LogComments} ${styles.wide}`}
                        >
                          <Skeleton
                            animation="wave"
                            variant="rounded"
                            width="90%"
                            height={20}
                          />
                        </td>
                        <td
                          className={`${styles.LogJobAddress}`}
                        >
                          <Skeleton
                            animation="wave"
                            variant="rounded"
                            width="90%"
                            height={20}
                          />
                        </td>
                        <td
                          className={styles.LogDescription}
                        >
                          <Skeleton
                            animation="wave"
                            variant="rounded"
                            width={150}
                            height={20}
                          />
                        </td>
                      </tr>
                    ))
                  : logBook &&
                  logBook.map((log) => (
                    <tr className={styles.LogRow} key={log.id}>
                      {(() => {
                        const statusKey = (log.project_status_name || log.status || '').toString().toUpperCase();
                        const isInvoice = statusKey === 'INVOICE';
                        const statusClass = isInvoice ? styles.InvoiceBubble : styles.ActiveBubble;
                        const statusText = isInvoice ? 'INVOICE' : 'ACTIVE';
                        return (
                          <td className={`${statusClass} ${styles.LogStatus}`}>
                            {statusText}
                          </td>
                        );
                      })()}
                      <td className={`${styles.LogActivity} ${styles.wide}`}>
                        {log.activity_type}
                      </td>
                      <td className={`${styles.LogJobAddress}`}>{log.project_number} - {log.project_address}</td>
                      <td className={`${styles.LogComments} ${styles.wide}`}>{log.comments}</td>
                      <td className={`${styles.LogDescription}`}>{log.description}</td>
                    </tr>
                  ))}
              </tbody>
            </table>
          </div>
        </div>

        {activeTab === 'Invoicing' && (
          <>
            {jobData.professional && (
              <>
                <div className={styles.SubTitle} style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                  <div style={{ display: 'flex', alignItems: 'center', gap: '18px' }}>
                    <span>Professional Project List</span>
                    {proAllRows.length > 0 && (
                      <div className={styles.InlineStats}>
                        <div className={styles.InlineStat}>
                          <span className={styles.InlineStatLabel}>Total Promoted</span>
                          <span className={styles.InlineStatValue}>{jobData?.total_promoted_fees || '£0.00'}</span>
                        </div>
                        <div className={styles.InlineStat}>
                          <span className={styles.InlineStatLabel}>Projects Promoted</span>
                          <span className={styles.InlineStatValue}>{jobData?.promoted_project_count || '0'}</span>
                        </div>
                        <div className={styles.InlineStat}>
                          <span className={styles.InlineStatLabel}>Win Rate</span>
                          <span className={styles.InlineStatValue}>{jobData?.win_rate || '0%'}</span>
                        </div>
                      </div>
                    )}
                  </div>
                  <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                    <span className={styles.InfoText} style={{ fontWeight: 700, color: '#949494' }}>Lost opps included</span>
                    <SliderSwitch checked={includeLostOpps} onToggle={setIncludeLostOpps} />
                  </div>
                </div>
                <div style={{ marginBottom: '24px' }}>
                  <Table data={{ ...proProjectListData, rows: proShownRows }} clickableRowAdd={'../projects/ProjectProfile'} />
                  <div className='pagination-container'>
                    <div></div>
                    <div className='pagination-info'>
                      {`Showing 1-${proShownCount} of ${proShownCount} records`}
                    </div>
                    <div></div>
                  </div>
                </div>
              </>
            )}
            {jobData.company && (
              <>
                <div className={styles.SubTitle} style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                  <div style={{ display: 'flex', alignItems: 'center', gap: '18px' }}>
                    <span>Company Project List</span>
                    {companyAllRows.length > 0 && (
                      <div className={styles.InlineStats}>
                        <div className={styles.InlineStat}>
                          <span className={styles.InlineStatLabel}>Total Promoted</span>
                          <span className={styles.InlineStatValue}>{jobData?.total_promoted_fees || '£0.00'}</span>
                        </div>
                        <div className={styles.InlineStat}>
                          <span className={styles.InlineStatLabel}>Projects Promoted</span>
                          <span className={styles.InlineStatValue}>{jobData?.promoted_project_count || '0'}</span>
                        </div>
                        <div className={styles.InlineStat}>
                          <span className={styles.InlineStatLabel}>Win Rate</span>
                          <span className={styles.InlineStatValue}>{jobData?.win_rate || '0%'}</span>
                        </div>
                      </div>
                    )}
                  </div>
                  <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                    <span className={styles.InfoText} style={{ fontWeight: 700, color: '#949494' }}>Lost opps included</span>
                    <SliderSwitch checked={includeLostOpps} onToggle={setIncludeLostOpps} />
                  </div>
                </div>
                <div style={{ marginBottom: '24px' }}>
                  <Table data={{ ...companyProjectListData, rows: companyShownRows }} clickableRowAdd={'../projects/ProjectProfile'} />
                  <div className='pagination-container'>
                    <div></div>
                    <div className='pagination-info'>
                      {`Showing 1-${companyShownCount} of ${companyShownCount} records`}
                    </div>
                    <div></div>
                  </div>
                </div>
              </>
            )}
            {jobData.home_owner && (
              <>
                <div className={styles.SubTitle} style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                  <div style={{ display: 'flex', alignItems: 'center', gap: '18px' }}>
                    <span>Home Owner Project List</span>
                    {bpAllRows.length > 0 && (
                      <div className={styles.InlineStats}>
                        <div className={styles.InlineStat}>
                          <span className={styles.InlineStatLabel}>Total Promoted</span>
                          <span className={styles.InlineStatValue}>{jobData?.total_promoted_fees || '£0.00'}</span>
                        </div>
                        <div className={styles.InlineStat}>
                          <span className={styles.InlineStatLabel}>Projects Promoted</span>
                          <span className={styles.InlineStatValue}>{jobData?.promoted_project_count || '0'}</span>
                        </div>
                        <div className={styles.InlineStat}>
                          <span className={styles.InlineStatLabel}>Win Rate</span>
                          <span className={styles.InlineStatValue}>{jobData?.win_rate || '0%'}</span>
                        </div>
                      </div>
                    )}
                  </div>
                  <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                    <span className={styles.InfoText} style={{ fontWeight: 700, color: '#949494' }}>Lost opps included</span>
                    <SliderSwitch checked={includeLostOpps} onToggle={setIncludeLostOpps} />
                  </div>
                </div>
                <div style={{ marginBottom: '24px' }}>
                  <Table data={{ ...BPProjectListData, rows: bpShownRows }} clickableRowAdd={'../projects/ProjectProfile'} />
                  <div className='pagination-container'>
                    <div></div>
                    <div className='pagination-info'>
                      {`Showing 1-${bpShownCount} of ${bpShownCount} records`}
                    </div>
                    <div></div>
                  </div>
                </div>
              </>
            )}
          </>
        )}

        {activeTab === 'Timesheets' && (
          <div className={styles.NoProjects} style={{ marginTop: '40px', textAlign: 'center', fontFamily: 'PT Sans, sans-serif', color: '#949494' }}>
            NO TIMESHEET DATA AVAILABLE FOR THIS CLIENT
          </div>
        )}

        {activeTab === 'Tasks' && (
          <PlannerTasksBoard
            tasks={plannerTasks.tasks}
            loading={plannerTasks.tasksLoading}
            error={plannerTasks.tasksError}
            userEmail={account?.username}
          />
        )}

        {displayEditDiv && (
          <EditClientProfilePopup
            clientData={jobData}
            onSubmit={handleUpdateClick}
            onDelete={handleDeleteClick}
            onClose={() => setDisplayEditDiv(false)}
          />
        )}

        {showAttachPopup && jobData && (
          <AttachClientRelationPopup
            isVisible={showAttachPopup}
            clientData={jobData}
            attachProfessionalOptions={attachProfessionalOptions}
            attachCompanyOptions={attachCompanyOptions}
            selectedProfessional={selectedProfessional}
            selectedCompany={selectedCompany}
            onChangeProfessional={(option) => setSelectedProfessional(option)}
            onChangeCompany={(option) => setSelectedCompany(option)}
            onSearchChange={handleAttachSearchChange}
            onAttachProfessional={async () => {
              await handleAttachProfessional();
              setShowAttachPopup(false);
            }}
            onAttachCompany={async () => {
              await handleAttachCompany();
              setShowAttachPopup(false);
            }}
            isSubmitting={isClientRelationSubmitting}
            onClose={() => setShowAttachPopup(false)}
          />
        )}

        {loading && (
          <div className={styles.ProjectProfileOverlay}>
            <div style={{ borderRadius: "150px", minWidth: "160px" }}>
              <CircularProgress size={65} />
            </div>
          </div>
        )}

        {isResponseShown && (
          <div className={styles.ProjectProfileOverlay}>
            <div className={styles.ProjectProfileResponseBox}>
              <div
                style={{
                  fontSize: 16,
                  fontFamily: "PT Sans",
                  textAlign: "center",
                  margin: "20px",
                  marginLeft: "25px",
                  marginRight: "25px",
                }}
                dangerouslySetInnerHTML={{ __html: apiResponse }}
              />

              <div style={{ display: "flex", justifyContent: "center" }}>
                <div
                  className={styles.ProjectProfileButton}
                  onClick={() => setIsResponseShown(false)}
                >
                  OK
                </div>
              </div>
            </div>
          </div>
        )}

        <ClientFollowUpPopUp
          isVisible={followUpModal}
          clientID={clientID}
          commentText={comment}
          onSubmit={() => {
            setComment("");
            setActivity("");
            fetchDataRecords();
          }}
          onClose={() => setFollowUpModal(false)}
        />
      </div>

    </div>
  );
}

export default ClientProfile;
